import React from 'react';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import {
    Description,
    EmptyState,
    EmptyStateIcon,
    Heading,
    TextSkeleton,
} from '@gitbook/spine-react';

import { ComputedSourceTitle } from './ComputedSourceTitle';
import { ContentSourceTranslationSpaceBlankslate } from './translation';

/**
 * Blankslate to display in the space when there are no pages generated by a
 * given source.
 */
export function ContentSourceSpaceBlankslate(props: {
    space: api.Space;
    source: api.ComputedContentSourceRevision;
}) {
    const { space, source } = props;

    switch (source.type) {
        case 'builtin:translation':
            return <ContentSourceTranslationSpaceBlankslate space={space} source={source} />;
        default:
            return (
                <EmptyState>
                    <EmptyStateIcon>
                        <Icon.Page />
                    </EmptyStateIcon>
                    <Heading>No content generated</Heading>
                    <Description>
                        <React.Suspense fallback={<TextSkeleton />}>
                            <ComputedSourceTitle source={source}>
                                {({ title }) => <>No content has been generated by {title}</>}
                            </ComputedSourceTitle>
                        </React.Suspense>
                    </Description>
                </EmptyState>
            );
    }
}
